export default "__VITE_ASSET__BCi9GmE5__"